/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Generated_Badge_TextInputs */

const en_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This content was generated with AI assistance (Mistral). You review and edit all suggestions before use; Alchema does not make automated hiring or employment decisions.`)
};

const de_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Inhalt wurde mit KI-Unterstützung (Mistral) erstellt. Sie prüfen und bearbeiten alle Vorschläge vor der Verwendung; Alchema trifft keine automatisierten Einstellungs- oder Beschäftigungsentscheidungen.`)
};

const fr_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce contenu a été généré avec l’assistance de l’IA (Mistral). Vous examinez et modifiez toutes les suggestions avant de les utiliser ; Alchema ne prend pas de décisions automatisées en matière de recrutement ou d’emploi.`)
};

const es_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este contenido se generó con asistencia de IA (Mistral). Revisas y editas todas las sugerencias antes de usarlas; Alchema no toma decisiones automatizadas de contratación ni de empleo.`)
};

const it_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo contenuto è stato generato con l’assistenza dell’IA (Mistral). Esamini e modifichi tutti i suggerimenti prima dell’uso; Alchema non prende decisioni automatizzate in materia di assunzione o impiego.`)
};

const nl_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze inhoud is met AI-ondersteuning (Mistral) gegenereerd. Je beoordeelt en bewerkt alle suggesties vóór gebruik; Alchema neemt geen geautomatiseerde beslissingen over werving of arbeid.`)
};

const pl_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta treść została wygenerowana z pomocą AI (Mistral). Przeglądasz i edytujesz wszystkie sugestie przed użyciem; Alchema nie podejmuje zautomatyzowanych decyzji dotyczących rekrutacji ani zatrudnienia.`)
};

const fi_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä sisältö tuotettiin tekoälyn avustuksella (Mistral). Tarkistat ja muokkaat kaikki ehdotukset ennen käyttöä; Alchema ei tee automatisoituja rekrytointi- tai työllistämispäätöksiä.`)
};

const da_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette indhold er genereret med hjælp fra AI (Mistral). Du gennemgår og redigerer alle forslag før brug; Alchema træffer ikke automatiserede beslutninger om rekruttering eller ansættelse.`)
};

const sv_ai_generated_badge_text = /** @type {(inputs: Ai_Generated_Badge_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det här innehållet genererades med hjälp av AI (Mistral). Du granskar och redigerar alla förslag före användning; Alchema fattar inga automatiserade beslut om rekrytering eller anställning.`)
};

/**
* | output |
* | --- |
* | "This content was generated with AI assistance (Mistral). You review and edit all suggestions before use; Alchema does not make automated hiring or employment..." |
*
* @param {Ai_Generated_Badge_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ai_generated_badge_text = /** @type {((inputs?: Ai_Generated_Badge_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Generated_Badge_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_generated_badge_text(inputs)
	if (locale === "fr") return fr_ai_generated_badge_text(inputs)
	if (locale === "es") return es_ai_generated_badge_text(inputs)
	if (locale === "it") return it_ai_generated_badge_text(inputs)
	if (locale === "nl") return nl_ai_generated_badge_text(inputs)
	if (locale === "pl") return pl_ai_generated_badge_text(inputs)
	if (locale === "fi") return fi_ai_generated_badge_text(inputs)
	if (locale === "da") return da_ai_generated_badge_text(inputs)
	if (locale === "sv") return sv_ai_generated_badge_text(inputs)
	return en_ai_generated_badge_text(inputs)
});